export const EditButtonTooltips = {
  draft: undefined,
  running:
    "Quality check pipeline is currently running. Please wait until it finishes.",
  declined: undefined,
  validated:
    "If you edit this asset, it will have to be re-validated by the Quality check pipeline",
};

export const RunQCButtonTooltips = {
  draft: undefined,
  running:
    "Quality check pipeline is already running for this asset draft. Please wait until it finishes.",
  declined: undefined,
  validated: undefined,
};

export const PublishButtonTooltips = {
  draft:
    "The current version of the asset has not been validated by the Quality check pipeline",
  running: "Cannot publish an asset that has a running Quality check pipeline",
  declined:
    "Cannot publish an asset that had failed to pass the Quality check pipeline.",
  validated: undefined,
};
